(() => {
  const SECTION_SELECTOR = '.loot-product-apps-fullwidth';
  const ROOT_SELECTORS = [
    '.loot-product-apps-fullwidth__inner',
    '.loot-product-apps-fullwidth__block',
    '.shopify-block',
    '.shopify-app-block',
    '#looxReviews',
    '.loox-reviews-default',
    '[id^="looxReviews"]',
    '[data-loox-widget]',
    '[class*="loox-reviews"]',
    '[class*="looxReviews"]',
    '[id*="judge"]',
    '[class*="jdgm-widget"]'
  ];

  const forceFullWidth = (section) => {
    ROOT_SELECTORS.forEach((selector) => {
      section.querySelectorAll(selector).forEach((element) => {
        element.style.setProperty('width', '100%', 'important');
        element.style.setProperty('max-width', 'none', 'important');
        element.style.setProperty('min-width', '0', 'important');
        element.style.setProperty('box-sizing', 'border-box', 'important');
        element.style.setProperty('grid-column', '1 / -1', 'important');
        element.style.setProperty('flex', '0 0 100%', 'important');
      });
    });
  };

  const refreshSection = (section) => {
    forceFullWidth(section);
    requestAnimationFrame(() => {
      forceFullWidth(section);
      window.dispatchEvent(new Event('resize'));
    });
  };

  const initSection = (section) => {
    if (!section || section.dataset.lootFullwidthReady === 'true') return;
    section.dataset.lootFullwidthReady = 'true';

    refreshSection(section);
    [80, 300, 900, 1800].forEach((delay) => {
      window.setTimeout(() => refreshSection(section), delay);
    });

    const observer = new MutationObserver(() => refreshSection(section));
    observer.observe(section, { childList: true, subtree: true });
  };

  const initAll = (root = document) => {
    root.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
